import { useSheetContext } from "@/context/sheet";
import { useCreateHotel } from "@/hooks/hotels";
import { CreateHotel } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(hotels)/hotels/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateHotel({
    onSuccess: (hotel) => {
      close(() => {
        navigate({
          to: "/hotels",
          params: { id: hotel.id.toString() },
        });
      });
    },
  });

  const create = async (hotel: CreateHotel) => {
    await mutateAsync(hotel);
  };

  return <Form onUpsert={create} />;
}
